import Header from "./features/Header"
import RandomSender from "./features/RandomSender";

function App() {
  
  return (
    <div className="flex flex-col items-center">
      <Header/>
      <RandomSender/>
    </div>
  )
}

export default App
